// Move the whole placement, including its value, marker and editor identity.
export function movePlacement(placements, from, to) {
  if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || to < 0
    || from >= placements.length || to >= placements.length || from === to) return placements;
  const next = [...placements];
  const [placement] = next.splice(from, 1);
  next.splice(to, 0, placement);
  return next.map((place, index) => ({ ...place, rank: index + 1 }));
}
